export function applyPolyfills() {
  if (!Object.hasOwn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.hasOwn = function hasOwnPolyfill(obj: any, key: string | symbol) {
      return Object.prototype.hasOwnProperty.call(obj, key);
    };
  }
}
